<template>
  <div>
    <div class="form_item" :class="save_to+'_wrapper'">
      <div :id="save_to+'_element'">
        <Label :required="required" :label="label" :for_id="save_to"/>
        <input
          v-validate="validationComputed"
          :id="save_to"
          :type="type"
          :name="validationLabel || label"
          :key="save_to"
          :ref="save_to"
          v-model="val"
          :required="required"
          :autocomplete="autocomplete"
          :class="{'has-error': errors.has(validationLabel || label) && ((fields[validationLabel || label].untouched && !fields[validationLabel || label].dirty) || (fields[validationLabel || label].touched && fields[validationLabel || label].dirty))}"
          :pattern="pattern"
          :placeholder="placeholder"
        />
      </div>
      <p v-if="info !== undefined" class="info" v-html="info"></p>
      <span
        class="error"
        v-show="errors.has(validationLabel || label) && ((fields[validationLabel || label].untouched && !fields[validationLabel || label].dirty) || (fields[validationLabel || label].touched && fields[validationLabel || label].dirty))"
        v-html="forceErrorMessage || errors.first(validationLabel || label)"
      ></span>
    </div>
    <div class="form_item" v-if="confirmation" :class="confirmationName+'_wrapper'">
      <div>
        <Label :required="required" :label="confirmationLabel" :for_id="confirmationName"/>
        <input
          v-validate="'required|confirmed:'+save_to"
          :id="confirmationName"
          :type="type"
          :name="confirmationName"
          :key="confirmationName"
          :ref="`confirmation_${save_to}`"
          required
          :class="{'has-error': errors.has(confirmationName)}"
          :inputmode="inputmode"
          :pattern="pattern"
          :placeholder="placeholder"
        />
      </div>
      <span
        class="error"
        v-show="errors.has(confirmationName) && ((fields[confirmationName].untouched && !fields[confirmationName].dirty) || (fields[confirmationName].touched && fields[confirmationName].dirty))"
        v-text="errors.first(confirmationName)"
      ></span>
    </div>
  </div>
</template>

<script>
import { validatorComponent } from './validatorComponentMixin';
import parseValidationRules from '../custom_rules/parseValidationRules';

import Label from './Label'

export default {
  name: 'Input',
  mixins: [validatorComponent],
  components: {
    Label
  },
  props: {
    save_to: String,
    type: {
      type: String,
      default: 'text'
    },
    required: {
      type: Boolean,
      default: false
    },
    validationLabel: String,
    unique: Boolean,
    _id : String,
    operationId : String,
    validationRules: [String, Object],
    validation: [String, Object],
    autocomplete: String,
    placeholder: String,
    confirmationLabel: String,
    testmode: {
      type: Object,
    },
    confirmation: {
      type: Boolean,
      default: false
    },
    confirmationInitialValue: String,
    inputmode: {
      type: String,
      default: 'text'
    },
    forceErrorMessage: String,
    pattern: String
  },
  created() {
    //this.confirmationInitialValue = this.val;
  },
  mounted() {
    if(this.$refs[`confirmation_${this.save_to}`] && this.val) {
      this.$refs[`confirmation_${this.save_to}`].value = this.val;
    }
  },
  computed: {
    confirmationName () {
      return this.save_to + '_confirmation';
    },
    validationComputed() {
      let validationRules = {...this.validationRules}
      if(typeof this.validation == 'string' && this.validation.length > 0) {
        validationRules = parseValidationRules(this.validation);
      }
      if(validationRules.included) {
        validationRules.included = validationRules.included.split(',');
      }
      if(this.unique && !(this.testmode && this.testmode.active && this.testmode.disableunique)) {
        return {...validationRules, unique: [this.save_to, this.operationId]};
      } else {
        return {...validationRules}
      }
    }
  }
};
</script>
